<template>
  <div>
    <header class="top">
      <div class="brand">Cost Tracker</div>
      <nav class="nav">
        <router-link to="/items" class="link" exact>Items</router-link>
        <router-link to="/categories" class="link">Categories</router-link>
      </nav>
      <button class="lock" @click="toggleEdit">
        {{ editLocked ? "🔒 已锁定" : "🔓 编辑中" }}
      </button>
      <!-- <button class="logout" @click="logout">退出</button> -->
         <!-- 根据登录状态切换 -->
      <button
        v-if="isLoggedIn"
        class="logout"
        @click="logout"
      >
        退出
      </button>

      <button
        v-else
        class="login"
        @click="goLogin"
      >
        登录
      </button>

    </header>

    <main class="main">
      <router-view :edit-locked="!editLocked" />
    </main>
  </div>
</template>

<script>
// import { clearToken } from "@/api/client";
import { clearToken, getToken } from "@/api/client";
export default {
  name: "Home",
  data() {
    return {
      editLocked: true, // 默认锁定
    };
  },
  computed: {
    isLoggedIn() {
      return !!getToken();
    },
  },
  methods: {
    logout() {
      clearToken();
      this.$router.replace("/login");
    },

    goLogin() {
      this.$router.push("/login");
    },
    toggleEdit() {
      this.editLocked = !this.editLocked;
    },
    logout() {
      clearToken();
      this.$router.replace("/login");
    },
  },
};
</script>

<style scoped>
.top { display:flex; align-items:center; gap:16px; padding:12px 16px; border-bottom:1px solid #eee; }
.brand { font-weight:700; }
.nav { display:flex; gap:12px; flex:1; }
.link { text-decoration:none; padding:6px 10px; border-radius:8px; }
.router-link-exact-active { background:#eef4ff; }
.logout { border:1px solid #ddd; background:#fff; border-radius:8px; padding:6px 10px; cursor:pointer; }
.main { padding: 16px; }
</style>